//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data () {
    return {
      isLoaded: false
    }
  },
  props: {
    hallOfFame: {
      type: Object,
      required: true
    },
    promotedVideo: {
      type: Object,
      required: true
    },
    videos: {
      type: Array,
      required: true
    }
  },
  methods: {
    onImgLoad () {
      this.isLoaded = true
    }
  }
}

